// frontend/src/components/SampleCertificates.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import '../styles/EBooks.css';

import sampleCertificateImage1 from '../../../certificates/Think5Whys Sample Certificate.png';
import sampleCertificateImage2 from '../../../certificates/Bhart Vikash Parisad Sample Certificate.jpeg';

const MyCertificate = () => {
    return (
       <div className="min-h-screen bg-black py-2">
            <div className='border-b border-blue-400 mb-2'>
                <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
                    📖 Sample Certificates
                </h2>
            </div>
            <div className="main-content mt-2">
                <div className="mt-2">
                    <div className="relative text-xl lg:text-xl text-yellow-200 mb-2">
                        <p>Think5Whys</p>
                    </div>
                    <div className="relative inset-0 flex justify-center">
                        <img src={sampleCertificateImage1} alt="Think5Whys Sample Certificate" style={{ maxWidth: '50%' }} />
                    </div>
                    <div className="relative mt-4 text-x lg:text-xl text-yellow-200 mb-2">
                        <p>Other Certifiers</p>
                    </div>
                    <div className="relative inset-0 flex justify-center">
                        <img src={sampleCertificateImage2} alt="Think5Whys Sample Certificate" style={{ maxWidth: '50%' }} />
                    </div>                    
                </div>
            </div>
            <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
                    <div className="flex flex-wrap gap-4 text-sm">
                        <Link to="/about-us" className="hover:text-teal-300">About</Link>
                        <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                        <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                    </div>
                </div>
            </footer>  
        </div>
    );
};

export default MyCertificate;
